import React from 'react';
interface GuaranteeLineProps {
  className?: string;
}
export function GuaranteeLine({
  className = ''
}: GuaranteeLineProps) {
  return <p className={`text-center text-xs text-mp-gray sm:text-sm ${className}`} data-id="element-254" data-mp="2xypkk11l7hsj">
      🛡️ Garantía 14 días &nbsp;·&nbsp; 💳 Pago único &nbsp;·&nbsp; ⚡ Acceso inmediato
    </p>;
}